export const BinTypes = {
    ARTWORK: 'bin.search.artworks',
    MONTAGE: 'bin.search.montages',
    TOOL: 'bin.search.tools',
  };
